<template>
    <div>
        <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mt-4 mb-3"
        >
            <div class="title">
                <h1 class="mb-0">Cubex Configurations</h1>
            </div>
        </div>
        <b-card footer-class="p-0" class="side-tab" style="min-height: 500px;">
            <div class="tab-body row">
                <div class="col-12 d-md-none mb-3" v-if="isCubexFeatureEnabled">
                    <b-dropdown 
                        :text="getCurrentTitle" 
                        class="w-100"
                        variant="outline-dark"
                    >
                        <b-dropdown-item
                            v-for="(title, index) in titles"
                            :key="index"
                            @click="selectTab(title.code)"
                            :disabled="index > 0 && isEmpty(cubexSettings)"
                            :active="activeTab === title.code"
                        >
                            {{ title.label }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
                <div
                    class="col-md-2 tabs d-none d-md-block"
                    v-if="isCubexFeatureEnabled"
                >
                    <div
                        class="text"
                        v-for="(title, index) in titles"
                        :key="index"
                        :class="{
                            active: activeTab === title.code,
                            disabled: index > 0 && isEmpty(cubexSettings)
                        }"
                        @click="selectTab(title.code)"
                    >
                        {{ title.label }}
                    </div>
                </div>
                <div
                    id="tab-details"
                    class="col-12 col-md-10"
                    v-if="isCubexFeatureEnabled"
                >
                    <div v-if="activeTab === 'cubex_settings'">
                        <CubexSetting
                            :cubex-settings="cubexSettings"
                            @reload="loadCubexSettings"
                        />
                    </div>
                    <div v-if="activeTab === 'export_users'">
                        <ExportUsers />
                    </div>
                    <div v-if="activeTab === 'export_items'">
                        <ExportItems />
                    </div>
                </div>
                <div class="col-md-10" v-else>
                    <loader-list />
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import CubexSetting from "@/components/setting-cubex/cubex-setting";
import CubexService from "@/services/setting/cubex";
import ExportUsers from "@/components/setting-cubex/export-users";
import ExportItems from "@/components/setting-cubex/export-items";
import FeaturesEnabledMixin from "@/mixins/features-enabled";
import LoaderList from "@/components/elements/loader-list";
import { isEmpty } from "lodash";

export default {
    mixins: [FeaturesEnabledMixin],
    components: {
        CubexSetting,
        ExportUsers,
        ExportItems,
        LoaderList
    },
    data() {
        return {
            isLoading: true,
            scrollTop: 0,
            activeModule: 0,
            titlePositions: [],
            activeTab: "cubex_settings",
            cubexSettings: {},
            titles: [
                {
                    code: "cubex_settings",
                    label: "Cubex Settings"
                },
                {
                    code: "export_users",
                    label: "Export Staff"
                },
                {
                    code: "export_items",
                    label: "Export Items"
                }
            ]
        };
    },
    async mounted() {
        if (this.isCubexFeatureEnabled) {
            await this.loadCubexSettings();
        }
    },
    watch: {
        isCubexFeatureEnabled: {
            handler(newVal) {
                if (!newVal) {
                    this._redirect(process.env.APPS + "business/business");
                }
            },
            immediate: true
        }
    },
    methods: {
        selectTab(tab) {
            if (tab !== "cubex_settings") {
                this.activeTab = isEmpty(this.cubexSettings)
                    ? this.titles[0].code
                    : tab;
            } else {
                this.activeTab = tab;
            }
        },
        async loadCubexSettings() {
            try {
                this.isLoading = true;
                const settings = await CubexService.getCubexSetting();

                // check if all the values are exist and not null
                if (
                    settings?.resources?.data &&
                    Object.values(settings.resources.data).every(
                        value => value !== null
                    )
                ) {
                    this.cubexSettings = settings.resources.data;
                } else {
                    this.cubexSettings = {};
                }

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this._message("Failed to load Cubex settings", "danger");
            }
        },
        isEmpty(value) {
            return isEmpty(value);
        }
    },
    computed: {
        getCurrentTitle() {
            const currentTitle = this.titles.find(title => title.code === this.activeTab);
            return currentTitle ? currentTitle.label : 'Select Option';
        }
    }
};
</script>

<style scoped>
.b-dropdown {
    width: 100%;
}

.dropdown-toggle {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dropdown-item.active {
    background-color: #343a40;
    color: white;
}
</style>
